import React, { useState } from "react";
import style from "./dropdownbodycontent.module.css";
function DropdownBodyContent(props) {
  const [showItems, setShowItems] = useState(props.items.map(() => false));

  const handleItemClick = (index) => {
    const newShowItems = [...showItems];
    newShowItems[index] = !newShowItems[index];
    setShowItems(newShowItems);
  };
  return (
    <div className={style.bodydropdown}>
      <p
      // className={style.title}
      >
        {props.title}
      </p>
      {props.items.length > 0 &&
        props.items.map((elem, index) => (
          <>
            <div className={style.content}>
              <span
                className={style.droptitle}
                onClick={() => handleItemClick(index)}
              >
                {showItems[index] ? (
                  <span>
                    <svg
                      width="15"
                      height="10"
                      viewBox="0 0 15 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 1.5L7.5 8.5L1 1.5"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                ) : (
                  <span>
                    <svg
                      width="9"
                      height="16"
                      viewBox="0 0 9 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.999999 1.5L8 8L1 14.5"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                )}
                <span className={style.subtitle}>
                  {elem.question[props.lang]}
                </span>
              </span>
              <span
                className={style.texte}
                style={
                  showItems[index]
                    ? {
                        height: "max-content",
                        padding: "10px",
                        overflow: "auto",
                        transition: "overflow 0.5s ease-out 0s",
                        textAlign: "start",
                      }
                    : {
                        height: "0px",
                        padding: "0px",
                        overflow: "hidden",
                        transition: "overflow 0.5s ease-out 0s",
                        textAlign: "start",
                      }
                }
              >
                {elem.response[props.lang]}
              </span>
            </div>
          </>
        ))}
    </div>
  );
}

export default DropdownBodyContent;
